import { DASHBOARD_ROUTES, SUPPLIER_ROUTES } from "shared/config/routes";

export const SUPPLIERS_NAV_ROUTES = [
    DASHBOARD_ROUTES.SUPPLIER_TRACKER,
    SUPPLIER_ROUTES.SUPPLIERS
]